import { Tag as AntTag, TagProps, Tooltip } from 'antd';
import React, { FC, useRef } from 'react';
import styled from 'styled-components';
import { theme } from '@tools/ui-utils/theme.util';

export const Tag = styled(AntTag)`
  text-transform: uppercase;
  margin-right: 0;
`;

export const CapitalizedTag = styled(AntTag)`
  text-transform: capitalize;
  margin-right: 0;
`;

const MAX_WIDTH = 150;

export const TagRoot = styled(AntTag)`
  padding: ${theme.spacing(0.5)}px ${theme.spacing()}px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: ${MAX_WIDTH}px;
`;

export const TagLabel: FC<React.PropsWithChildren<TagProps>> = (props) => {
  const ref = useRef<HTMLInputElement>(null);

  return (
    <Tooltip
      placement="top"
      title={
        ref.current && ref?.current?.offsetWidth >= MAX_WIDTH
          ? props.children
          : ''
      }
    >
      <TagRoot {...props} ref={ref}>
        {props.children}
      </TagRoot>
    </Tooltip>
  );
};

type ITagProps = {
  colorMap: Record<string, string>;
  colorKey: string;
  defaultKey?: string;
};

const ColorTag: FC<React.PropsWithChildren<ITagProps>> = ({
  colorMap,
  colorKey,
  defaultKey = '',
  children
}) => {
  const color = colorMap[colorKey] || colorMap[defaultKey];

  return <Tag color={color}>{children}</Tag>;
};

export default ColorTag;
